import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { initCommonTranslate } from 'Utils/languages';
import OpenNewWindowIcon from 'Components/icons/OpenNewWindowIcon/OpenNewWindowIcon.jsx';
import DownloadIcon from 'Components/icons/download-icon/DownloadIcon.jsx';

import './EditableInput.scss';

import ChangingProgressProvider from "Components/ChangingProgressProvider/ChangingProgressProvider.js";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { COLORS } from "Constants/BIDashboardConstants"

export class EditableInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputDirty: false,
      inputContent: props.content,
      inputSizeContent: props.sizeContent,
      showErrorMessage: false,
    };

    initCommonTranslate();
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.content !== this.props.content) {
      this.setState({
        inputContent: nextProps.content,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  onBlur = () => {
    this.props.getCurrent(this.state.inputContent);
  }

  handleClickOutside = (event) => {
    if (this.editableInputContainer && this.state.inputDirty && !this.editableInputContainer.contains(event.target)) {
      this.setState({
        inputDirty: false,
      });
      this.editableInputField.blur();
    }
  }

  handleChange = (event) => {
    this.setState({
      inputContent: event.target.value,
    });
  }

  editContent = () => {
    if (!this.state.inputDirty) {
      this.setState({
        inputDirty: true,
      });
      this.editableInputField.focus();
      this.editableInputField.setSelectionRange(0, this.editableInputField.value.length);
    } else {
      this.setState({
        inputDirty: false,
      });
      this.editableInputField.blur();
    }
  }

  render() {
    const { label, errorMessage, placeholder, extraClass, maxLength, readOnly, sizeLabel } = this.props;
    const { inputDirty, inputContent, inputSizeContent } = this.state;
    const showErrorMessage = Boolean(errorMessage.length);

    const isDownloadPermission = this.props.parsedPermissions && this.props.parsedPermissions.document && this.props.parsedPermissions.document.download;
    const editableLabelWrapper = classnames('editable-input__label', {
      error: showErrorMessage,
    });

    const editableContentWrapper = classnames('editable-input__content', {
      error: showErrorMessage,
    });

    const wrapperClass = classnames('editable-input', {
      [extraClass]: extraClass,
    });

    return (
      <div className={wrapperClass} ref={(ref) => (this.editableInputContainer = ref)}>
        {
          readOnly ?
            <div className="unMatchfileInput">
            <div className="uneditable-input">
              <span className={editableLabelWrapper}>
                {label}
                {
                  showErrorMessage && (
                    <div className="message-error">
                      {errorMessage}
                    </div>
                  )}
              </span>
              <span style={{color:'#000000'}}>
                {inputContent}
              </span>
            </div>
            <div className="uneditableSize-input" id="File Size">
              <span className={editableLabelWrapper}>
                {sizeLabel}
                {
                  showErrorMessage && (
                    <div className="message-error">
                      {errorMessage}
                    </div>
                  )}
              </span>
              <span>
                {inputSizeContent} MB
              </span>
            </div>
            </div>
            :
            <div className="editable-input__edit">
              <input
                className={editableContentWrapper}
                type="text"
                ref={(input) => { this.editableInputField = input; }}
                placeholder={placeholder}
                readOnly
                onChange={this.handleChange}
                onFocus={this.editContent}
                value={inputContent}
                onBlur={this.onBlur}
                maxLength={maxLength}
              />
            </div>
        }
        {!this.props.downloadInProgress && isDownloadPermission
          && <div className="open-document-download">
            <DownloadIcon
              onClick={this.props.downloadDocument}
              height={20}
              width={20}
            />
          </div>
        }
        {
          this.props.downloadInProgress &&
          <div className="document-loading">

            <ChangingProgressProvider
              values={[12, 20, 48, 52, 57, 63, 69, 72, 77, 83, 88, 93, 100]}
              pauseValue={93}
            >
              {percentage => (
                <CircularProgressbar value={percentage} text={`${percentage}%`}
                  styles={buildStyles({
                    pathColor: COLORS.oneGp.globalBlue,
                    textColor: COLORS.oneGp.globalBlue,
                    textSize: "25px"
                  })} />
              )}
            </ChangingProgressProvider>
          </div>
        }
        {
          !this.props.hideOpenDocButton && (
            <div className={isDownloadPermission ? "open-document" : "open-document-download"}>
              <OpenNewWindowIcon
                onClick={this.props.openDocument}
                height={20}
                width={20}
              />
            </div>
          )}
      </div>
    );
  }
}

EditableInput.propTypes = {
  content: PropTypes.string,
  label: PropTypes.string,
  getCurrent: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  extraClass: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  readOnly: PropTypes.bool,
  parsedPermissions: PropTypes.object,
};

EditableInput.defaultProps = {
  content: '',
  errorMessage: '',
  extraClass: '',
  label: '',
  placeholder: '',
  maxLength: 255,
  readOnly: false,
};

export default EditableInput;
